import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/map")({
  beforeLoad: async () => {
    // This route is deprecated, so we redirect to the new "/maps" route
    return redirect({ to: "/maps" });
  },
});
